import React from "react";
import { FaEye, FaShieldAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { formatDate } from "./utils/formatDate";

const cellClass = "px-2 py-2 sm:px-3 sm:py-2 text-xs sm:text-sm";

export default function TopUsersTable({
  users,
  backendPage,
  backendLimit,
  formatDate: formatDateProp,
  onVerifyUser,
}) {
  const navigate = useNavigate();
  const format = formatDateProp || formatDate;

  if (!users.length) {
    return (
      <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white shadow min-w-0">
        <table className="min-w-full text-left border-collapse">
          <thead className="bg-gray-50">
            <tr>
              <th className={cellClass}>SR. NO</th>
              <th className={cellClass}>First Name</th>
              <th className={cellClass}>Last Name</th>
              <th className={cellClass}>Email</th>
              <th className={cellClass}>Contact</th>
              <th className={cellClass}>Created</th>
              <th className={cellClass}>Document</th>
              <th className={cellClass}>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="8" className="px-4 py-8 text-center text-sm text-gray-500">
                No users found
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white shadow min-w-0">
      <table className="min-w-full text-left border-collapse">
        <thead className="bg-gray-50 text-gray-700">
          <tr>
            <th className={`${cellClass} font-semibold uppercase tracking-wider`}>SR. NO</th>
            <th className={`${cellClass} font-semibold uppercase tracking-wider`}>First Name</th>
            <th className={`${cellClass} font-semibold uppercase tracking-wider`}>Last Name</th>
            <th className={`${cellClass} font-semibold uppercase tracking-wider`}>Email</th>
            <th className={`${cellClass} font-semibold uppercase tracking-wider`}>Contact</th>
            <th className={`${cellClass} font-semibold uppercase tracking-wider`}>Created</th>
            <th className={`${cellClass} font-semibold uppercase tracking-wider`}>Document</th>
            <th className={`${cellClass} font-semibold uppercase tracking-wider`}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, idx) => (
            <tr
              key={user.id}
              className="hover:bg-gray-50 border-b border-gray-100 last:border-0">
              <td className={cellClass}>
                {(backendPage - 1) * backendLimit + idx + 1}
              </td>
              <td className={`${cellClass} font-medium text-gray-900 whitespace-nowrap`}>
                {user.firstName ?? "—"}
              </td>
              <td className={`${cellClass} whitespace-nowrap`}>
                {user.lastName ?? "—"}
              </td>
              <td className={`${cellClass} text-gray-600 max-w-[120px] sm:max-w-[180px] truncate`}>
                {user.email ?? "—"}
              </td>
              <td className={`${cellClass} whitespace-nowrap`}>
                {user.contactNo ?? "—"}
              </td>
              <td className={`${cellClass} whitespace-nowrap`}>
                {user.createdDate ? format(user.createdDate) : "N/A"}
              </td>
              <td
                className={`${cellClass} font-semibold whitespace-nowrap ${
                  user.document === "Not Uploaded" ? "text-red-500" : "text-green-500"
                }`}>
                {user.document || "Not Uploaded"}
              </td>
              <td className={`${cellClass}`}>
                <div className="flex gap-2 sm:gap-3 items-center">
                  <button
                    type="button"
                    onClick={() => navigate(`/userdetails/${user.id}`)}
                    className="relative group p-1 rounded hover:bg-gray-100"
                    title="View">
                    <FaEye className="text-red-500 cursor-pointer" />
                    <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 hidden group-hover:block bg-gray-700 text-white text-xs px-2 py-1 rounded whitespace-nowrap z-10">
                      View
                    </span>
                  </button>
                  <button
                    type="button"
                    onClick={() => onVerifyUser(user)}
                    className="relative group p-1 rounded hover:bg-gray-100"
                    title="Verify profile pic">
                    <FaShieldAlt className="text-red-500 cursor-pointer" />
                    <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-1 hidden group-hover:block bg-gray-700 text-white text-xs text-center px-2 py-1 rounded w-[135px] z-10">
                      Verify User Profile Pic
                    </span>
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
